<template>

  <AppModal
    :showFooter = false
    :show="modalActive"
    class='modal-term'
    @update:close="closeModal"
    @closeModal="closeModal"
    :extraClass='`modal-how-it-work`'
  >
    <template #header>
      <div class="dib black fs-18 lh-28 fw-700 mr-15">
        How it works
      </div>
    </template>
    <template #body>
      <div class="modalContent" >
        <HowItWork/>
        <div class="nml-20 nmr-20 bd-b-1 bd-gray-200">
          <h5 class="pl-20 pr-20 fw-700 lh-28 fs-18 bd-b-1 bd-gray-200 pt-8 pb-8">
            About us
          </h5>
          <ul class="pl-20 pr-20">
            <AboutUsContent :hasTitle="false"/>
          </ul>
        </div>
        <div class="pt-10 pb-12">
          <button @click="closeModal()" class="custom-button button-black button wp-100">Got it</button>
        </div>
      </div>
    </template>


  </AppModal>

</template>
<script>
import AppModal from '~/components/ui/modal/AppModal'
import HowItWork from "~/components/ui/how-it-work-popup-content/HowItWorkContent";
import AboutUsContent from "~/components/ui/how-it-work-popup-content/AboutUsContent";
import {assetCDN} from '~/helper/index.js';

export default {
  name: 'ModalHowItWorks',
  props: {
    modalActive: {
      type: Boolean,
      default: false,
    },

  },
  components: {
    // PopupCommon,
    AppModal,
    HowItWork,
    AboutUsContent
  },
  emits: ['closeModal'],
  setup(props, { emit }) {
    const closeModal = () => {
      emit('closeModal')
    }

    const ASSETS_CDN = assetCDN()

    return {
      ASSETS_CDN,
      closeModal
    }
  },
}
</script>
<style lang="scss" scoped>
:deep(.modal-how-it-work) {
  .custom-option {
    max-height: none;
    padding-top: 0;
  }
  .modal-header {
    border-color: $gray-200;
  }
}
.custom-button {
  font-size: 16px;
  line-height: 24px;
  border-radius: 6px;
}
</style>
